import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Dock extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    isVisible: PropTypes.bool,
    onVisibleChange: PropTypes.func,
    position: PropTypes.oneOf(["left", "right", "top", "bottom"]),
    size: PropTypes.number
  };

  static defaultProps = {
    position: "left",
    onVisibleChange: () => undefined
  };

  state = { isMounted: false };

  componentDidMount() {
    // Wait for initial animation to be done, this is to avoid flickering on app load
    this.mountingTimeout = setTimeout(() => this.setState({ isMounted: true }), 400);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isVisible !== prevProps.isVisible) this.updateVisibility();
  }

  componentWillUnmount() {
    clearTimeout(this.mountingTimeout);
  }

  getDockStyles = () => {
    const { position, isVisible, size } = this.props;
    const absSize = `${size * 100}%`;
    const restSize = `${100 - size * 100}%`;

    switch (position) {
      case "left":
        return { left: isVisible ? 0 : `-${absSize}`, width: absSize };
      default:
      case "right":
        return { left: isVisible ? restSize : "100%", width: absSize };
      case "top":
        return { top: isVisible ? 0 : `-${absSize}`, height: absSize };
      case "bottom":
        return { top: isVisible ? restSize : "100%", height: absSize };
    }
  };

  mountingTimeout;

  updateVisibility = () => {
    if (!this.props.isVisible) {
      setTimeout(() => {
        document.body.style["-webkit-overflow-scrolling"] = "touch";
      }, 300);
    } else {
      document.body.style["-webkit-overflow-scrolling"] = "auto";
    }
  };

  handleDimClick = () => this.props.onVisibleChange(false);

  render() {
    const { children, isVisible } = this.props;
    const { isMounted } = this.state;

    const dimClasses = classNames("dock__dim", { "dock__dim--appear": !isVisible });
    const dockClasses = classNames("dock__dock", { "dock__dock--hidden": isMounted && !isVisible, "dock__dock--mounting": !isMounted });
    const dockStyles = this.getDockStyles();

    return (
      <div className="dock">
        {isVisible && <div className={dimClasses} onClick={this.handleDimClick} role="none" />}
        <div className={dockClasses} style={dockStyles}>
          <div className="dock__content">{children}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Dock.js